import React from 'react';
import logoHorizontalSrc from '../assets/brand/td-monogram-trail-horizontal.svg';
import logoSymbolSrc from '../assets/brand/td-monogram-trail-symbol.svg';
import { BRAND_LOGO_TOKENS, BRAND_WORDMARK } from '../brand/logoTokens';

const clampLogoSize = (size) => {
  const numeric = Number(size);
  if (!Number.isFinite(numeric)) {
    return BRAND_LOGO_TOKENS.minPx;
  }
  return Math.max(BRAND_LOGO_TOKENS.minPx, Math.round(numeric));
};

export const BrandLogoMark = ({ size = BRAND_LOGO_TOKENS.minPx, className = '', alt = `${BRAND_WORDMARK} logo` }) => {
  const clamped = clampLogoSize(size);
  return (
    <img
      src={logoSymbolSrc}
      width={clamped}
      height={clamped}
      alt={alt}
      loading="eager"
      decoding="async"
      className={className}
      data-brand-logo-version={BRAND_LOGO_TOKENS.version}
      data-brand-logo-ratio={BRAND_LOGO_TOKENS.ratio}
      data-brand-logo-lock="td-monogram-trail"
    />
  );
};

export const BrandLogoWithWordmark = ({ size = 28, showWordmark = true, className = '' }) => {
  const clamped = clampLogoSize(size);
  if (!showWordmark) {
    return (
      <div className={`brand-logo-lockup ${className}`.trim()} data-brand-logo-lockup={BRAND_LOGO_TOKENS.version}>
        <BrandLogoMark size={clamped} />
      </div>
    );
  }

  return (
    <div className={`brand-logo-lockup ${className}`.trim()} data-brand-logo-lockup={BRAND_LOGO_TOKENS.version}>
      <img
        src={logoHorizontalSrc}
        width={Math.round(clamped * 3.6)}
        height={clamped}
        alt={`${BRAND_WORDMARK} logo`}
        loading="eager"
        decoding="async"
        data-brand-logo-version={BRAND_LOGO_TOKENS.version}
        data-brand-logo-ratio={BRAND_LOGO_TOKENS.lockupRatio}
        data-brand-logo-lock="td-monogram-trail"
      />
    </div>
  );
};

export default BrandLogoWithWordmark;
